import React, { useEffect, useRef } from "react";

import Card from "../Card/Card";
import "./AboutSection.css";

const AboutSection = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const elements = sectionRef.current.querySelectorAll(".reveal");

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("reveal-active");
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section id="about" className="about-wrapper" ref={sectionRef}>
      <div className="about-inner">
      {/* BLUR SHAPES */}
      <div className="about-blur-shape" aria-hidden="true" />
      <div className="about-blur-shape two" aria-hidden="true" />

      <div className="about-container">

        {/* IMAGE */}
        <div className="about-image-wrapper reveal">
          <img src="https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091838/AboutImage_xj4j0k.png" alt="About" className="about-image" />
        </div>

        {/* TEXT */}
        {/*Just checking something*/}
        <div className="about-text reveal">
          <h5>About Me</h5>
          <h2>
            I’m a Professional Graphic<br />
            & Digital Designer.
          </h2>

          <p>
            I’m a Creative Designer skilled in crafting visually engaging,
            user-focused solutions across digital and brand experiences. I
            combine strong design principles, strategic thinking, and creative
            storytelling to deliver clean, impactful visuals.
          </p>

          <p>
            I specialize in Graphic Design, Web Design, UI/UX, Branding, and
            Mobile App Design — creating cohesive, accessible designs that
            connect with audiences and support business goals.
          </p>

          <a href="/RemzyArtsCV.pdf" download>
            <button className="CV">Download CV</button>
          </a>
        </div>

      </div>

      {/* STATS CARDS */}
      <div className="about-cards reveal">
        <Card number="06" symbol="+" label="Years of Experience" />
        <Card number="500" symbol="+" label="Projects Completed" />
        <Card number="100" symbol="%" label="Clients Satisfaction" />
      </div>

      {/* PLATFORM TEXT */}
      <div className="platform-text reveal">
        <h5>PLATFORM</h5>
        <h2>What Softwares do I Use?</h2>
      </div>

      {/* PLATFORM CARDS */}
      <div className="platform-cards reveal">
        <Card icon="https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091832/photoshop_i9kuni.png" label="Adobe Photoshop" />
        <Card icon="https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091842/illustrator_uu5woy.png" label="Adobe Illustrator" />
        <Card icon="https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091828/figma_hwcutu.png" label="Figma" />
        <Card icon="https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091827/canva_bmlj2g.png" label="Canva" />
        <Card icon="https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091833/wordpress_eyfkym.png" label="WordPress" />
        <Card icon="https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091846/vscode_iancej.png" label="VS Code" />
      </div>
    </div>
    </section>
  );
};

export default AboutSection;
